var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityFinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#F4536E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59242 6.93V4.125C6.59242 3.09 7.43242 2.25 8.46742 2.25C9.50242 2.25 10.3424 3.09 10.3424 4.125V6.93C11.2499 6.3225 11.8424 5.295 11.8424 4.125C11.8424 2.2575 10.3349 0.75 8.46742 0.75C6.59992 0.75 5.09242 2.2575 5.09242 4.125C5.09242 5.295 5.68492 6.3225 6.59242 6.93ZM10.7174 8.7825C10.5074 8.6775 10.2824 8.625 10.0499 8.625H9.59242V4.125C9.59242 3.5025 9.08992 3 8.46742 3C7.84492 3 7.34242 3.5025 7.34242 4.125V12.18L4.76242 11.64C4.48492 11.58 4.19242 11.67 3.98992 11.8725C3.66742 12.2025 3.66742 12.7275 3.98992 13.0575L6.99742 16.065C7.28242 16.3425 7.66492 16.5 8.06242 16.5H12.6374C13.3874 16.5 14.0174 15.9525 14.1224 15.21L14.5949 11.8575C14.6849 11.22 14.3549 10.59 13.7774 10.305L10.7174 8.7825Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityFinger);
export default __webpack_public_path__ + "static/media/activity-finger.39612295.svg";
export { ForwardRef as ReactComponent };